import { useContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

/* STORE PAGES */
import Home from "../../pages/Home/Home";
import Products from "../../pages/Products/Products";
import Users from "../../pages/Users/Users";
import ExpiredProducts from "../../pages/ExpiredProducts/ExpiredProducts";

/* ADMIN PAGES */
import Admin from "../../pages/Admin/Admin";
import Stores from "../../pages/Stores/Stores";
import ExpiredProductsManagement from "../../pages/ExpiredProductsManagement/ExpiredProductsManagement";
import UserManagment from "../../pages/UserManagement/UserManagment";
import Import from "../../pages/Import/Import";
import Settings from "../../pages/Settings/Settings";
import NotFound from "../../pages/NotFound/NotFound";

/* SUPER ADMIN PAGES */
import SuperAdmin from "../../ui/superadmin/SuperAdmin";
import Clients from "../../ui/clients/Clients";
import UsersAdmin from "../../ui/users/Users";

/* UTILS */
import { RoutesWithSidebar } from "../../utils/RoutesWithSidebar";
import { RoutesWithNavbar } from "../../utils/RoutesWithNavbar";
import { RoutesWithFooter } from "../../utils/RoutesWithFooter";

/* COMPONENTS */
import Sidebar from "../../../src/components/Sidebar/Sidebar";
import Navbar from "../../../src/components/Navbar/Navbar";
import Footer from "../../../src/components/Footer/Footer";

/* MODALS */
import ModalManager from '../../components/Modals/ModalManager'; 
import { ModalProvider } from '../../context/ModalContext';

const Private = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  if (loading) {
    return <div className="loading"></div>;
  }
  if (!user) {
    return <Navigate to="/painel/home" />;
  }
  return children;
};

export const MainContent = () => {
  const { pathname } = useLocation();
  const routesWithSidebar = RoutesWithSidebar()
  const routesWithNavbar = RoutesWithNavbar()
  const routesWithFooter = RoutesWithFooter()
  const shouldShowSidebar = routesWithSidebar.includes(pathname);
  const shouldShowNavbar = routesWithNavbar.includes(pathname);
  const shouldShowFooter = routesWithFooter.includes(pathname);
  
  return (
    <ModalProvider>
      <>
      <ModalManager/>
        { shouldShowSidebar && <Sidebar />}
        { shouldShowNavbar && <Navbar />}
        { shouldShowFooter &&  <Footer />}

        <Routes>
          <Route path="/home" element={<Home />} />

          <Route
            path="/produtos"
            element={
              <Private>
                <Products />
              </Private>
            }
          />

          <Route
            path="/produtos-vencidos"
            element={
              <Private>
                <ExpiredProducts />
              </Private>
            }
          />

          <Route
            path="/usuarios"
            element={
              <Private>
                <Users />
              </Private>
            }
          />

          <Route
            path="/configuracao"
            element={
            <Private><Settings/></Private>
            }
          />
        
          <Route 
            path="/admin"
            element={
              <Admin/>
            } 
            />

          <Route
            path="/admin/lojas"
            element={
              <Private><Stores/></Private>
            }
          />

          <Route
            path="/admin/usuarios"
            element={
              <Private><UserManagment/></Private>
            }
          />

          <Route
            path="/admin/controle-validade"
            element={
              <Private><ExpiredProductsManagement/></Private>
            }
          />

          <Route
            path="/admin/importacao"
            element={
            <Private><Import/></Private>
            }
          />

          <Route
            path="/admin/configuracao"
            element={
            <Private><Settings/></Private>
            }
          />

          <Route
            path="/superadmin"
            element={
              <SuperAdmin/>
            }
          />

          <Route
            path="/superadmin/clientes"
            element={
              <Private><Clients/></Private>
            }
          />

          <Route
            path="/superadmin/usuarios"
            element={
              <Private><UsersAdmin/></Private>
            }
          />

          <Route path="*" element={<NotFound /> } /> 

        </Routes>
       
      </>
    </ModalProvider>
  );
}